(function () {
    'use strict';

    angular
        .module('app.book')
        .controller('BookController', BookController);

    BookController.$inject = ['$scope', '$filter', '$state', 'common', 'dataservice', 'completionsDataService',
        'userService', 'backendHubProxy', '$interval', 'notesDataService', 'config' ];
    /* @ngInject */
    function BookController($scope, $filter, $state, common, dataservice, completionsDataService, userService, 
        backendHubProxy, $interval, notesDataService, config ) {
        var vm = this;
        var _defaultRefreshTime = 600000;
        vm.common = common;
        vm.connectionStatus = "";
        vm.showDailySetup = userService.hasOps() == "1";
        vm.isLoading = true;
        vm.title = "Book";
        vm.refresh = refresh;
        vm.completionsDataService = completionsDataService;
        vm.notesDataService = notesDataService;
        vm.userService = common.userService;
        vm.dataService = dataservice;
        vm.noDataMessage = "";
        vm.items = [];
        vm.displayedItems = [];
        vm.today = function () {
            common.notifier.notify(config.events.mainDateToday);
        }
        vm.filterRooms = filterRooms;
        vm.lastRefreshed = "loading";
        vm.showRoomCode = window.localStorage.getItem("OpsShowRoomCode") == "true" ? true : false;
        vm.roomCodeText = vm.showRoomCode ? "Show Room Description" : "Show Room Code";
        vm.toggleShowRoomCode = toggleShowRoomCode;
        vm.bookData = [];
        vm.displayedBookData = [];
        
        vm.onDate = common.getMainState("mainDate");
       
        vm.allCompletionTypes = [];
        
        vm.settings = [];
        
        vm.filtersSet = false;

        vm.filtersForDailySetup = {}; 
        vm.showHelp = false;
        vm.apiVersion = 0;
        vm.apiTypeId = common.userService.apiTypeId();
        vm.eventBarColor = "#1171a3";
        vm.reservedBarColor = "grey";
        vm.cancelledBarColor = "red";
        vm.textColor = "white";
        vm.searchText = "";
        vm.filters = {
            GmtFromDate: '1/1/2015',
            GmtToDate: new Date().toUTCString(),
            Buildings: [-1],
            Statuses: [-1],
            Categories: [-1],
            Views: [],
            Udfs: [],
            LimitToBookingsWithSelectedCategories: false,
            LocalDateOnlyIsoString: moment(vm.onDate).format("YYYY-MM-DD"),
            ShowEventsWithinThisManyDays : null
        };

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });

        vm.applyFilter = null;
       
        activate();

        function toggleShowRoomCode() {
            
            vm.showRoomCode = !vm.showRoomCode;
            window.localStorage.setItem("OpsShowRoomCode", '' + vm.showRoomCode);
            if (vm.showRoomCode) {
                vm.roomCodeText = "Show Room Description";
            }
            else {
                vm.roomCodeText = "Show Room Code";
            }
            
        }

        function activate() {
            common.notifier.subscribe(common.config.events.signalRStatusChange, $scope, function (eventName, data) {
                vm.connectionStatus = data;
            });

            _initFilters();
            backendHubProxy.displayedItems = vm.displayedItems;
            backendHubProxy.bookData = vm.bookData;
            var clone = structuredClone(vm.bookData);
            backendHubProxy.displayedBookData = clone;
            vm.displayedBookData = clone;

            backendHubProxy.startListening();

            common.notifier.subscribe(common.config.events.userConfigOptionsChange, $scope, filtersChanged);
            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);
            completionsDataService.clearCache();
            var promises = [loadData()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(common.config.events.refreshCounts);
             
                vm.isLoading = false;
                
                vm.applyFilter = common.createSearchThrottle(vm, 'bookData', 'displayedBookData', 'bookFilter');
                
                
            }, function (error) { });
        }

        //we need this for signalr stuff
        $scope.$watchCollection('vm.displayedItems', function (newCollection, oldCollection, scope) {
            //_setBookingCollections();
        })
        vm.bookFilter = bookFilter;
        function bookFilter(item) {
            var lowerSearch = vm.searchText.toLowerCase();
            if (lowerSearch.length == 0)
                return item;

            var filteredRooms = item.Rooms.filter(function (r) {
                
                if (r.Description.toLowerCase().indexOf(lowerSearch) != -1) {
                    return r;
                }
            });
            item.Rooms = filteredRooms;
            if (item.Rooms.length > 0) {
                return item;
            }
            
        }

        function filterRooms() {
            vm.applyFilter();
            //common.createSearchThrottle()
            //console.log(vm.searchText);
        }
        
        function _initFilters() {

            var gmtToDate = new Date();
            gmtToDate.setHours(0, 0, 0, 0);
            vm.filters.GmtToDate = moment(gmtToDate).add(1, 'd').toDate();

            var filterData = userService.filterData();

            if (filterData) {
                if (filterData.categories) {
                    var roomChargeIndex = filterData.categories.indexOf("2147483647");
                    if (roomChargeIndex > -1) {
                        filterData.categories.splice(roomChargeIndex, 1);
                    }
                }
                
                vm.filters.Buildings = filterData.buildings;
                vm.filters.Statuses = filterData.statuses;
                vm.filters.Categories = filterData.categories;
                vm.filters.RoomTypes = filterData.roomTypes || [];
                vm.filters.EventTypes = filterData.eventTypes || [];
                vm.filters.Views = filterData.views || [];
                vm.filters.Udfs = filterData.udfs || [];
                vm.filters.LimitToBookingsWithSelectedCategories = filterData.includeBookingWithCategoriesOnly;
                vm.minutesSinceLastChangeFlag = filterData.highlightChangesWithin;
                vm.filters.showReservedTimes = filterData.showReservedTimes;
                vm.filters.ShowEventsWithinThisManyDays = filterData.ShowEventsWithinThisManyDays;
            }
            $scope.filters = filterData;
        }
       
        function _setfilterDates() {
            var gmtFromDate = new Date(vm.onDate);
            gmtFromDate.setHours(0, 0, 0, 0);
            vm.filters.GmtFromDate = gmtFromDate;
            vm.filters.LocalDateOnlyIsoString = moment(vm.onDate).format("YYYY-MM-DD")
            vm.filters.GmtToDate = moment(gmtFromDate).add(1, 'd').toDate();
        }

        function filtersChanged(eventName, data) {
            
            _initFilters();
            getItems();
        }

        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            getItems();
        }

        function loadData() {
            if (vm.apiTypeId !== common.config.apiTypes.centersXml) {
                if (!vm.filters.Buildings || !vm.filters.Statuses) {
                    common.logger.error("Filters aren't set");
                    vm.filtersSet = false;
                    return;
                }
                else {
                    vm.filtersSet = true;
                }
            }
            else {
                vm.filtersSet = true;
            }

            _setfilterDates();


            return dataservice.query('api/Book/InitData', vm.filters).then(function (response) {
               
                var loadData = response.data;
                //console.log(loadData);
                vm.settings = loadData.Settings;
                vm.allCompletionTypes = loadData.CompletionTypes;
                vm.apiVersion = loadData.ApiVersion;
                if (!loadData.BookData) {
                    common.logger.error("Whoops....It looks like there was a problem loading your data, if the problem persists contact 7 Point Solutions.")
                }
                vm.bookData = loadData.BookData || [];
                vm.displayedBookData = structuredClone(vm.bookData)
                
                _processItems(loadData.Data);

                

                for (var i = 0; i < vm.settings.length; i++) {
                    if (vm.settings[i].SettingKey == "BookReservedColor") {
                        vm.reservedBarColor = vm.settings[i].SettingValue;
                    }
                    else if (vm.settings[i].SettingKey == "BookEventColor") {
                        vm.eventBarColor = vm.settings[i].SettingValue;
                    }
                    else if (vm.settings[i].SettingKey == "BookTextColor") {
                        vm.textColor = vm.settings[i].SettingValue;
                    }
                    else if (vm.settings[i].SettingKey == "BookCancelledColor") {
                        vm.cancelledBarColor = vm.settings[i].SettingValue;
                    }
                }
               
                return vm.items;
            }, function (error) { });

        }

        function getItems() {

            _stop();
            _setfilterDates();
            vm.lastRefreshed = "loading"
            if (vm.filters.ShowEventsWithinThisManyDays) {
                var gmtFromDate = moment(vm.filters.GmtFromDate);
                var lastDate = new Date();
                lastDate.setHours(0, 0, 0, 0);
                if (moment(lastDate).add(vm.filters.ShowEventsWithinThisManyDays, 'days').isBefore(gmtFromDate)) {
                    vm.noDataMessage = "Your filter does not allow you to see data on this date";
                }
                else {
                    vm.noDataMessage = "No data matches you filters";
                }
            }

            return dataservice.query('api/Book', vm.filters).then(function (response) {
                var data = response.data;
                vm.bookData = data.BookData;
                vm.displayedBookData = structuredClone(data.BookData)
                _processItems(data.Data);
                
                

            }, function (error) { });
        }

        function _processItems(items) {
            if (!items) {
                items = [];
            }
            else if (items.Message) {
                common.logger.error("An error occurred trying to load you items, you should contact 7 Point Solutions if the problem persists");
                items = [];
            }
            

            for (var i = 0; i < items.length; i++) {
                items[i].BuildingLocalReseveredStartDisplay = moment(items[i].BuildingLocalReseveredStart).format("LT");
                items[i].BuildingLocalReseveredEndDisplay = moment(items[i].BuildingLocalReseveredEnd).format("LT");
                items[i].BuildingLocalEventStartDisplay = moment(items[i].BuildingLocalEventStart).format("LT");
                items[i].BuildingLocalEventEndDisplay = moment(items[i].BuildingLocalEventEnd).format("LT"); 
            }

            vm.items = [];
            vm.items = items;
            
            vm.displayedItems = [].concat(vm.items);
            vm.origTasks = [];
            vm.origAllBookings = [];
            items.map(function (item) {
                if (item.TaskId == 0) {
                    vm.origAllBookings.push(item);
                }
                else {
                    vm.origTasks.push(item);
                }
            })
            
            backendHubProxy.items = vm.items;
            backendHubProxy.displayedItems = vm.displayedItems;
            backendHubProxy.bookData = vm.bookData || [];
            if (vm.bookData) {
                var clone = structuredClone(vm.bookData);
                backendHubProxy.displayedBookData = clone;
                vm.displayedBookData = clone;
            }
            
            _refreshDataIn = _defaultRefreshTime;
            vm.lastRefreshed = moment().format("hh:mm A");
            _start();
        }

        function refresh() {
            getItems();
        }


        var _timerPromise, _tickPromise, _refreshDataIn = _defaultRefreshTime;

        function _tick() {
            
            if (_refreshDataIn >= 0) {
                _refreshDataIn = _refreshDataIn - 1000;
            }
            else {
                _refreshDataIn = _defaultRefreshTime;
            }
        }

        function _stop() {
            common.$timeout.cancel(_timerPromise);
            $interval.cancel(_tickPromise);
        }

        function _start() {
            _stop();
            _tickPromise = $interval(_tick, 1000);
            _timerPromise = common.$timeout(getItems, _refreshDataIn);
        }


        $scope.$on('$destroy', function () {
            _stop();
        });

   

    }
})();
